@use 'variables' as *;
@use 'mixins' as *;

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

.label-aria {
  @include cat-visually-hidden;
}

.cat-time-addon {
  margin-left: -1px;
  display: flex;
}

.time-disabled {
  opacity: 0.25;
}
